import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { ActiveErrorData, ActiveErrorsStore, DevicesStore, InstallationDetailsStore } from '@store';

import { DatesService } from '../../../../../../shared/services/dates.service';
import { matTooltipSetter } from '../../../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';
import { PillType } from '../../../../../../shared/components/pill/pill.model';

@Component({
  selector: 'app-active-error-tile',
  templateUrl: './active-error-tile.component.html',
  styleUrls: ['./active-error-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveErrorTileComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }
  readonly pillType = PillType;
  gatewaySerial: string;
  installationLocalTimeOfErrorAppearedAt: string;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  @Input() activeError: ActiveErrorData;

  constructor(
    public activeErrorsStore: ActiveErrorsStore,
    public devicesStore: DevicesStore,
    private activatedRoute: ActivatedRoute,
    private installationDetailsStore: InstallationDetailsStore,
    private datesService: DatesService
  ) {}

  ngOnInit(): void {
    this.gatewaySerial = this.activatedRoute.snapshot.queryParams['gatewaySerial'];
    this.subscribeToTimezone();
  }

  selectError(selectedErrorId: number): void {
    this.activeErrorsStore.selectActiveError(this.gatewaySerial, selectedErrorId);
  }

  private subscribeToTimezone(): void {
    this.installationDetailsStore.installationTimezone$
      .pipe(filter(Boolean), takeUntil(this.ngUnsubscribe$))
      .subscribe((timeZone: string) => {
        this.installationLocalTimeOfErrorAppearedAt = this.datesService.getMomentFormattedDateForSpecificTimezone(
          this.activeError.appearedAt,
          timeZone
        );
      });
  }
}
